<template>
  <div class="company-tooltip textOverflow">
    <a-tooltip
      v-if="$getStrleng(text) > 4"
      :title="text"
      overlay-class-name="td-tooltip"
    >
      {{ $substr(text, 4) }}
    </a-tooltip>
    <span v-else>{{ text || '- -' }}</span>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: ''
    }
  }
}
</script>
